var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    d: "M181 62L187 66 193 62",
    transform: "translate(-180 -60)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIconMobile);
export default __webpack_public_path__ + "static/media/expand-icon-mobile.69466cecc62e8de2d9b23ab798ebfc55.svg";
export { ForwardRef as ReactComponent };